/**
 * support-nav-dropdown-standalone.js
 *
 * Standalone — zero imports, runs in its own <script type="module"> tag so it
 * executes even if the main src/index.js module graph fails (e.g. analytics.js
 * blocked by an ad blocker).
 */
(function initSupportNavDropdown() {
  const STYLE_ID      = 'exl-support-nav-dropdown-styles';
  const INJECTED_ATTR = 'data-exl-support-dd';
  const MENU_ID       = 'exl-support-nav-dropdown-panel';

  const MENU_ITEMS = [
    { label: 'Support Home',    icon: '🏠', tab: 'home',        description: 'Your support dashboard',           highlight: false, external: false },
    { label: 'Open a Ticket',   icon: '📋', tab: 'open-ticket', description: 'Submit a new support case',        highlight: false, external: false },
    { label: 'My Cases',        icon: '📁', tab: 'my-cases',    description: 'Track your existing cases',        highlight: false, external: false },
    { label: 'T-Mobile',          icon: '📱', tab: 'T-Mobile',      description: 'T-Mobile KBO portal',              highlight: true,  external: false },
    { label: 'Community Forums',icon: '💬', tab: null,          description: 'Get help from the community',     highlight: false, external: true  },
  ];

  function buildSupportUrl(tab) {
    const parts = window.location.pathname.split('/').filter(Boolean);
    const lang  = parts[0] || 'en';
    return '/' + lang + '/support?support-tab=' + tab + '#' + tab;
  }

  function itemHref(item) {
    if (item.external) return 'https://experienceleague.adobe.com/en/community/forums';
    return buildSupportUrl(item.tab);
  }

  // ── Styles ────────────────────────────────────────────────────────────────

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = [
      '.exl-support-nav-chevron{display:inline-block;width:0;height:0;margin-left:5px;',
      'vertical-align:middle;border-left:4px solid transparent;border-right:4px solid transparent;',
      'border-top:5px solid currentColor;transition:transform 180ms ease;pointer-events:none;}',

      '[data-exl-dd-open] .exl-support-nav-chevron{transform:rotate(180deg);}',

      '#' + MENU_ID + '{position:fixed;z-index:99999;min-width:290px;padding:8px 0;margin:0;',
      'list-style:none;background:#fff;border:1px solid #e1e1e1;border-radius:10px;',
      'box-shadow:0 10px 30px rgba(0,0,0,.14),0 2px 6px rgba(0,0,0,.07);display:none;}',

      '#' + MENU_ID + '.is-open{display:block;animation:exlSddIn 150ms ease both;}',
      '@keyframes exlSddIn{from{opacity:0;transform:translateY(-5px)}to{opacity:1;transform:translateY(0)}}',

      '#' + MENU_ID + ' li{display:block;padding:0;margin:0;}',
      '#' + MENU_ID + ' li+li{border-top:1px solid #f2f2f2;}',
      '#' + MENU_ID + ' li.exl-sdd-divider{border-top:1px solid #ccc!important;margin-top:2px;padding-top:2px;}',

      '#' + MENU_ID + ' a{display:flex;align-items:flex-start;gap:12px;padding:10px 16px;',
      'text-decoration:none!important;color:#2c2c2c!important;transition:background 120ms;cursor:pointer;}',
      '#' + MENU_ID + ' a:hover,#' + MENU_ID + ' a:focus{background:#f4f6fa;outline:none;}',
      '#' + MENU_ID + ' a:focus-visible{outline:2px solid #1473e6!important;outline-offset:-2px;}',

      '.exl-sdd-icon{font-size:1.05rem;flex:0 0 auto;margin-top:2px;line-height:1;}',
      '.exl-sdd-body{display:flex;flex-direction:column;gap:2px;}',
      '.exl-sdd-label{font-size:.88rem;font-weight:600;color:#2c2c2c;line-height:1.3;}',
      '.exl-sdd-label.is-hi{color:#1473e6;}',
      '.exl-sdd-desc{font-size:.76rem;color:#6e6e6e;line-height:1.4;}',
    ].join('');
    document.head.appendChild(s);
  }

  // ── Panel ─────────────────────────────────────────────────────────────────

  function buildPanel() {
    var existing = document.getElementById(MENU_ID);
    if (existing) return existing;

    var ul = document.createElement('ul');
    ul.id = MENU_ID;
    ul.setAttribute('role', 'menu');

    MENU_ITEMS.forEach(function(item, i) {
      var li = document.createElement('li');
      li.setAttribute('role', 'none');
      if (i === MENU_ITEMS.length - 1) li.classList.add('exl-sdd-divider');

      var a = document.createElement('a');
      a.href = itemHref(item);
      a.setAttribute('role', 'menuitem');
      if (item.external) { a.target = '_blank'; a.rel = 'noopener noreferrer'; }

      a.innerHTML =
        '<span class="exl-sdd-icon" aria-hidden="true">' + item.icon + '</span>' +
        '<span class="exl-sdd-body">' +
          '<span class="exl-sdd-label' + (item.highlight ? ' is-hi' : '') + '">' + item.label + '</span>' +
          '<span class="exl-sdd-desc">' + item.description + '</span>' +
        '</span>';

      li.appendChild(a);
      ul.appendChild(li);
    });

    document.body.appendChild(ul);
    return ul;
  }

  // ── Positioning ───────────────────────────────────────────────────────────

  function positionPanel(panel, anchor) {
    var r = anchor.getBoundingClientRect();
    var w = panel.offsetWidth || 290;
    var left = r.left + r.width / 2 - w / 2;
    left = Math.max(8, Math.min(left, window.innerWidth - w - 8));
    panel.style.top  = (r.bottom + 6) + 'px';
    panel.style.left = left + 'px';
  }

  // ── Inject dropdown onto the found link ───────────────────────────────────

  function injectDropdown(supportLink) {
    console.log('[SupportNavDropdown] injecting on:', supportLink.outerHTML.slice(0, 180)); // eslint-disable-line no-console

    // Append chevron
    var chevron = document.createElement('span');
    chevron.className = 'exl-support-nav-chevron';
    chevron.setAttribute('aria-hidden', 'true');
    supportLink.appendChild(chevron);

    var panel = buildPanel();

    function openMenu() {
      positionPanel(panel, supportLink);
      panel.classList.add('is-open');
      supportLink.setAttribute('data-exl-dd-open', '');
      var first = panel.querySelector('a');
      if (first) first.focus();
    }

    function closeMenu() {
      panel.classList.remove('is-open');
      supportLink.removeAttribute('data-exl-dd-open');
    }

    supportLink.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      panel.classList.contains('is-open') ? closeMenu() : openMenu();
    });

    panel.addEventListener('keydown', function(e) {
      var items = Array.from(panel.querySelectorAll('a'));
      var idx   = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); var next = items[(idx + 1) % items.length]; if (next) next.focus(); }
      if (e.key === 'ArrowUp')   { e.preventDefault(); var prev = items[(idx - 1 + items.length) % items.length]; if (prev) prev.focus(); }
      if (e.key === 'Escape' || e.key === 'Tab') { closeMenu(); supportLink.focus(); }
    });

    document.addEventListener('click', function(e) {
      if (!supportLink.contains(e.target) && !panel.contains(e.target)) closeMenu();
    });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeMenu(); });
    document.addEventListener('scroll',  closeMenu, { passive: true });
    window.addEventListener('resize', function() {
      if (panel.classList.contains('is-open')) positionPanel(panel, supportLink);
    });
  }

  // ── Discovery ─────────────────────────────────────────────────────────────

  function isSupportNavLink(el) {
    if (!el || el.hasAttribute(INJECTED_ATTR)) return false;

    // Milo FEDS uses daa-ll="Support" on nav links (most reliable)
    if (el.getAttribute('daa-ll') === 'Support') return true;

    var href = (el.getAttribute('href') || '').toLowerCase();
    var text = el.textContent.trim().toLowerCase();

    // feds-navLink class + href contains /support
    if (el.classList.contains('feds-navLink') && href.indexOf('/support') !== -1) return true;

    // Text is exactly "support" and inside a nav context
    if (text === 'support') {
      if (el.closest('header, nav, [role="navigation"], [class*="nav"]')) return true;
    }

    return false;
  }

  function findSupportLink() {
    // 1. Direct daa-ll attribute (Milo FEDS — most reliable)
    var byDaa = document.querySelector('[daa-ll="Support"]');
    if (byDaa && !byDaa.hasAttribute(INJECTED_ATTR)) return byDaa;

    // 2. feds-navLink anchors with /support in href
    var byClass = document.querySelector('a.feds-navLink[href*="support"]');
    if (byClass && !byClass.hasAttribute(INJECTED_ATTR)) return byClass;

    // 3. Walk anchors/buttons — text === "support" inside a nav container
    var all = document.querySelectorAll('a, button');
    for (var i = 0; i < all.length; i++) {
      if (isSupportNavLink(all[i])) return all[i];
    }
    return null;
  }

  // ── Boot ──────────────────────────────────────────────────────────────────

  console.log('[SupportNavDropdown] standalone script loaded'); // eslint-disable-line no-console
  injectStyles();

  function tryInject() {
    var link = findSupportLink();
    if (!link) return false;
    link.setAttribute(INJECTED_ATTR, 'true');
    injectDropdown(link);
    return true;
  }

  if (tryInject()) return;

  console.log('[SupportNavDropdown] nav not ready yet — watching'); // eslint-disable-line no-console

  var observer = new MutationObserver(function() {
    if (tryInject()) {
      observer.disconnect();
      clearInterval(poll); // eslint-disable-line no-use-before-define
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  var attempts = 0;
  var poll = setInterval(function() {
    attempts += 1;
    if (tryInject() || attempts >= 50) {
      clearInterval(poll);
      observer.disconnect();
      if (attempts >= 50) {
        console.warn('[SupportNavDropdown] gave up after 15 s. header innerHTML:', // eslint-disable-line no-console
          (document.querySelector('header') || {}).innerHTML
        );
      }
    }
  }, 300);
}());
